/**
 * Rein clientseitiger, nicht-persistenter UI-Zustand für die geöffnete Workspace-Ansicht:
 * aktiver Tab und ggf. eine im Dateien-Tab geöffnete Datei (client.md §11/§12).
 * Wird sowohl von Rail (Datei-Tree) als auch von Workspace/Files (Tabbar/Content) gebraucht.
 */
import { create } from "zustand";
import type { TabId, ViewMode } from "../texte";

type UiState = {
  tab: TabId;
  openDoc: string | null;
  /** Sicht für Home/Wizard, wenn gerade kein Arbeitsbereich geöffnet ist — rein session-lokal,
   * da es dort keinen Workspace-Eintrag gibt, an dem eine Sicht dauerhaft hängen könnte. */
  sessionView: ViewMode;
  setTab: (t: TabId) => void;
  openFile: (docId: string) => void;
  closeFile: () => void;
  resetForWorkspace: (initialTab?: TabId) => void;
  setSessionView: (v: ViewMode) => void;
};

export const useUi = create<UiState>((set) => ({
  tab: "verlauf",
  openDoc: null,
  sessionView: "admin",
  setTab: (t) => set({ tab: t, openDoc: null }),
  // Always land on the Dateien tab so list, rail tree and search share one preview path.
  openFile: (docId) => set({ tab: "dateien", openDoc: docId }),
  closeFile: () => set({ openDoc: null }),
  resetForWorkspace: (initialTab = "verlauf") => set({ tab: initialTab, openDoc: null }),
  setSessionView: (v) => set({ sessionView: v }),
}));
